import { render, staticRenderFns } from "./ChatRefVote.vue?vue&type=template&id=7b048092&"
import script from "./ChatRefVote.vue?vue&type=script&lang=js&"
export * from "./ChatRefVote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports